import { useTranslation } from "react-i18next";
import { Label } from 'reactstrap'
import '../../../../styles/ahu-test.css'
import '../../../../styles/main.scss'

import { CheckboxOptions, CheckboxDefaultValue } from '../common/checkboxConfig'
import CheckboxGroup from "../common/CheckboxGroup";
import { MeasurementField } from "../common/MeasurementField";

const ElectricalMeasurementsForm2 = () => {
    const { t } = useTranslation();

    return (
        <form className="ahutest-container" >
            <Label className="ahutest-from--title">{t("Continuity")}</Label>
            <div className="flexboxAlignedColumn" style={{ padding: "2%" }}>
                <div className="ahutest-form__label--grid2">
                    <Label className="grid-item-label" >{t("Inlet fan")}</Label>
                    <CheckboxGroup
                        options={CheckboxOptions}
                        defaultValue={CheckboxDefaultValue}
                        measurementKey="inletFan-continuity"
                    />
                </div>
                <MeasurementField properyName='inletFan-continuity' unit="Ω" gap="10px" />

                <div className="ahutest-form__label--grid2" >
                    <Label className="grid-item-label" >{t("Exhaust fan")}</Label>
                    <CheckboxGroup
                        options={CheckboxOptions}
                        defaultValue={CheckboxDefaultValue}
                        measurementKey="exhaustFan-continuity"
                    />

                </div>
                <MeasurementField properyName='exhaustFan-continuity' unit="Ω" gap="10px" />


                <div className="ahutest-form__label--grid2" style={{ gap: "10px" }}>
                    <Label className="grid-item-label" >{t("LTO")}</Label>
                    <CheckboxGroup
                        options={CheckboxOptions}
                        defaultValue={CheckboxDefaultValue}
                        measurementKey="lto-continuity"
                    />

                </div>
                <MeasurementField properyName='lto-continuity' unit="Ω" gap="10px" />


                <div className="ahutest-form__label--grid2" style={{ gap: "10px" }}>
                    <Label className="grid-item-label" >{t("Electric heater")}</Label>
                    <CheckboxGroup
                        options={CheckboxOptions}
                        defaultValue={CheckboxDefaultValue}
                        measurementKey="electricHeater-continuity"
                    />

                </div>
                <MeasurementField properyName='electricHeater-continuity' unit="Ω" gap="10px" />


                <div className="ahutest-form__label--grid2" style={{ gap: "10px" }}>
                    <Label className="grid-item-label" >{t("Circulating water pump")}</Label>
                    <CheckboxGroup
                        options={CheckboxOptions}
                        defaultValue={CheckboxDefaultValue}
                        measurementKey="circulatingWaterPump-continuity"
                    />

                </div>
                <MeasurementField properyName='circulatingWaterPump-continuity' unit="Ω" gap="10px" />


                <div className="ahutest-form__label--grid2" style={{ gap: "10px" }}>
                    <Label className="grid-item-label" >{t("Damper motors")}</Label>
                    <CheckboxGroup
                        options={CheckboxOptions}
                        defaultValue={CheckboxDefaultValue}
                        measurementKey="damperMotors-continuity"
                    />

                </div>
                <MeasurementField properyName='damperMotors-continuity' unit="Ω" gap="10px" />


                <div className="ahutest-form__label--grid2" style={{ gap: "10px" }}>
                    <Label className="grid-item-label" >{t("Compressor")}</Label>
                    <CheckboxGroup
                        options={CheckboxOptions}
                        defaultValue={CheckboxDefaultValue}
                        measurementKey="compressor-continuity"
                    />

                </div>
                <MeasurementField properyName='compressor-continuity' unit="Ω" gap="10px" />

            </div>
        </form>
    )
}

export default ElectricalMeasurementsForm2